import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  TrackOrderStatusAction,
  closeWin,
  openWin,
  payOrderAction,
} from "../../redux/actions/orderStatus/orderStatusAction";
import {
  // openLoader,
  openLoader,
} from "../../redux/actions/loader/loaderActions";
import { useTimerContext } from "../../hooks/use-timer-context";
import { Post } from "../../api/client";
import styles from "./pay-with-momo-mali.module.scss";
import { ClipLoader } from "react-spinners";
import { openToastAndSetContent } from "../../redux/actions/toast/toastActions";
import { ToastErrorStyles } from "../../constants/toastStyles";

type Props = {
  reference: string;
};

const COUNTRY_CODES: Record<string, string> = {
  GHS: "+233",
  KES: "+254",
};

// const XOF_COUNTRIES = [
//   {
//     id: 1,
//     phone_code: "+221",
//     country: "Senegal",
//     flag: "/assets/images/flags/senegal-flag.svg",
//   },
//   {
//     id: 2,
//     phone_code: "+225",
//     country: "Côte d'Ivoire",
//     flag: "/assets/images/flags/cote-d-ivoire-flag.svg",
//   },
//   {
//     id: 3,
//     phone_code: "+229",
//     country: "Benin",
//     flag: "/assets/images/flags/benin-flag.svg",
//   },
//   {
//     id: 4,
//     phone_code: "+226",
//     country: "Burkina Faso",
//     flag: "/assets/images/flags/burkina-faso-flag.svg",
//   },
// ];

export const PayWithMomoMali: React.FC<Props> = ({ reference }) => {
  const { orderDetails } = useSelector((state) => state.orderDetailsReducer);

  const [telcoProviders, setTelcoProviders] = useState<any[] | null>(null);
  const [selectedProvider, setSelectedProvider] = useState<any | null>(null);
  const [phoneNumber, setPhoneNumber] = useState("");
  const dispatch = useDispatch();
  const { startTimer } = useTimerContext();
  const [isLoading, setIsLoading] = useState(false);

  const currency: string = orderDetails?.data?.order?.currency ?? "";
  const isXof = currency.toLowerCase() === "xof";
  const countryCode = COUNTRY_CODES[currency] ?? "";
  // const [selectedXofCountry, setSelectedXofCountry] = useState(
  //   XOF_COUNTRIES[0]
  // );
  // const [isXofDropdownOpen, setIsXofDropdownOpen] = useState(false);
  // const dropdownRef = useRef<HTMLDivElement>(null);

  // useEffect(() => {
  //   const handleClickOutside = (e: MouseEvent) => {
  //     if (
  //       dropdownRef.current &&
  //       !dropdownRef.current.contains(e.target as Node)
  //     ) {
  //       setIsXofDropdownOpen(false);
  //     }
  //   };
  //   document.addEventListener("mousedown", handleClickOutside);
  //   return () => document.removeEventListener("mousedown", handleClickOutside);
  // }, []);
  // const effectiveCountryCode = isXof
  //   ? selectedXofCountry.phone_code
  //   : countryCode;
  const effectiveCountryCode = isXof ? "" : countryCode;

  const updatePendingStatus = (__window: Window | null) => {
    closeWin(__window);
  };

  function openWin(redirectUrl: string) {
    const myWindow = window.open(redirectUrl, "_blank");
    if (myWindow) {
      myWindow.focus();
    } else {
      dispatch(
        openToastAndSetContent({
          toastStyles: ToastErrorStyles,
          toastContent:
            "The redirect to the payment page was blocked by your browser, please enable the redirect to complete payment",
        }),
      );
    }
  }

  const handleMakePayment = () => {
    try {
      setIsLoading(true);
      startTimer();
      const payload = {
        reference: reference,
        paymentoption: "MOMO-MALI",
        country: "",
        mobileMoney: {
          mobileNumber: `${effectiveCountryCode}${phoneNumber}`,
          mobileMoneyCode: selectedProvider?.code,
        },
      };

      payOrderAction(payload, "MOMO-MALI", dispatch, (data: any) => {
        const redirectUrl = data.data.paymentDetail.redirectUrl;
        if (redirectUrl) {
          openWin(redirectUrl);
        }
        setTimeout(() => {
          TrackOrderStatusAction(
            payload,
            "MOMO-MALI",
            dispatch,
            updatePendingStatus,
          );
        }, 1000);
      });

      // Post("payment/order/pay", payload).then((data) => {
      //   setIsLoading(false);
      //   dispatch(openLoader("Loading...", ""));
      //   TrackOrderStatusAction(payload, "momo", dispatch, updatePendingStatus);
      // });
      dispatch(openLoader("Loading...", ""));
    } catch (error: any) {
    } finally {
      setIsLoading(false);
    }
  };

  const MOMOMALI = "MOMO-MALI";
  useEffect(() => {
    const telcoProviders = orderDetails?.data?.otherPaymentOptions?.find(
      (opt: any) => opt?.code?.toUpperCase() === MOMOMALI,
    )?.providerOptions?.[0]?.providerPaymentOptions;

    if (telcoProviders) {
      setTelcoProviders(telcoProviders);
      return;
    }
  }, []);

  return (
    <div className={styles.container}>
      {isLoading ? (
        <ClipLoader color="#8e173e" size={40} />
      ) : (
        <>
          <div className={styles.phoneInputWrapper}>
            <label className={styles.label}>Mobile Number</label>
            <div className={styles.phoneInputRow}>
              {/* {isXof ? (
                <div ref={dropdownRef} className={styles.flagDropdown}>
                  <button
                    type="button"
                    className={styles.flagDropdownTrigger}
                    onClick={() => setIsXofDropdownOpen((o) => !o)}
                  >
                    <img
                      src={selectedXofCountry.flag}
                      alt={selectedXofCountry.country}
                      className={styles.flagImg}
                    />
                    <span>{selectedXofCountry.phone_code}</span>
                    <span className={styles.flagDropdownChevron}>▾</span>
                  </button>
                  {isXofDropdownOpen && (
                    <ul className={styles.flagDropdownList}>
                      {XOF_COUNTRIES.map((c) => (
                        <li
                          key={c.id}
                          className={`${styles.flagDropdownItem} ${
                            c.id === selectedXofCountry.id
                              ? styles.flagDropdownItemActive
                              : ""
                          }`}
                          onClick={() => {
                            setSelectedXofCountry(c);
                            setIsXofDropdownOpen(false);
                          }}
                        >
                          <img
                            src={c.flag}
                            alt={c.country}
                            className={styles.flagImg}
                          />
                          <span>{c.phone_code}</span>
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              ) : (
                <span className={styles.countryCode}>{countryCode}</span>
              )} */}
              {!isXof && (
                <span className={styles.countryCode}>{countryCode}</span>
              )}
              <input
                className={styles.phoneInput}
                type="tel"
                placeholder="Enter mobile number"
                value={phoneNumber}
                onChange={(e) =>
                  setPhoneNumber(e.target.value.replace(/\D/g, ""))
                }
              />
            </div>
          </div>
          {telcoProviders && telcoProviders?.length > 0 && (
            <div className={styles.selectWrapper}>
              <label className={styles.label}>Mobile Network</label>
              <select
                className={styles.select}
                value={selectedProvider?.code ?? ""}
                onChange={(e) =>
                  setSelectedProvider(
                    telcoProviders.find((p) => p.code === e.target.value) ??
                      null,
                  )
                }
              >
                <option value="" disabled>
                  Select network
                </option>
                {telcoProviders.map((prov: any) => (
                  <option key={prov.code} value={prov.code}>
                    {prov.name}
                  </option>
                ))}
              </select>
            </div>
          )}

          <button
            className={styles.payButton}
            disabled={
              !!(telcoProviders?.length && !selectedProvider) ||
              phoneNumber.length < 5
            }
            onClick={handleMakePayment}
          >
            Pay Now
          </button>
        </>
      )}
    </div>
  );
};
